import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';
import initialStateAgentLedState from './agent-led/api/initial-state-agent-led';
import { updateAgentLedDataReducer } from './agent-led/functions/update-agent-led-data';
// DOCS: Sync Method calls

export const agentLedSlice = createSlice({
  name: 'agentLed',
  initialState: initialStateAgentLedState,
  reducers: {
    ...updateAgentLedDataReducer,
  },
  extraReducers: {},
});

const { updateAgentLedData } = agentLedSlice.actions;

export function useAgentLedStore() {
  const isAgentLedJourney = useSelector(
    (state) => state.agentLed.isAgentLedJourney
  );
  const agentId = useSelector(
    (state) => state.agentLed.agentLedJourneyCustomerData.agentId
  );
  const merchantId = useSelector(
    (state) => state.agentLed.agentLedJourneyCustomerData.merchantId
  );
  const agentLedJourneyCustomerData = useSelector(
    (state) => state.agentLed.agentLedJourneyCustomerData
  );

  const dispatch = useDispatch();
  return {
    // TODO: State returns here
    agentId,
    merchantId,
    isAgentLedJourney,
    agentLedJourneyCustomerData,

    // DOCS: Write sync methods here
    updateAgentLedData: (payload) => dispatch(updateAgentLedData(payload)),
  };
}

export default agentLedSlice.reducer;
